<template>
    <div :data-cy="$attrs['data-cy'] || 'input_simple_password'">
        <div class="text-sm" data-cy="text_input_password_label">{{txtLabel}}</div>
        <div class="relative">
            <input type="password"
                class="w-full border bg-white px-3 py-1 placeholder-gray-500"
                v-model="content"
                :placeholder="txtPlaceholder"
                @input="onChange()"
                data-cy="input_input_password_field">
        </div>
    </div>
</template>
<script>
import RegxHelper from "@/helper/RegxHelper.js";

export default {
    name: "InputText",
    props: {
        //v-model
        inputValue: String,
        //props
        minLength: Number,
        maxLength: Number,
        isTextOnly: Boolean,
        //text
        txtLabel: String,
        txtPlaceholder: String,
    },
    data: function() {
        return {
            content: this.inputValue,
        };
    },
    methods: {
        onChange: function() {
            var result = this.content;

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }

            this.content = result;
            this.$emit('update:inputValue', result);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
